<template>
  <div class="stepper-wrapper">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step"
      :class="{ completed: currentStep >= index + 1 }"
    >
      <div class="step-index" v-text="index + 1" />
      <div class="step-label" v-text="step" />
      <i v-if="index + 1 < steps.length" class="bi bi-chevron-right" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  steps: {
    type: Array,
    required: true,
  },
  currentStep: {
    type: Number,
    required: true,
  },
});
</script>
